import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/cpwm.styles.css";

export const CPWM = () => {
	return <SubserviceWrapper config={services.cpwm} />;
};
